







































import Vue, { VueConstructor } from "vue";
import validationMixin from "@/components/mixins/validationMixin";
import policiesMixin from "@/components/mixins/policiesMixin";
import { languagesOptions } from "@/services/languagesService";

export default (
  Vue as VueConstructor<
    Vue &
      InstanceType<typeof policiesMixin> &
      InstanceType<typeof validationMixin>
  >
).extend({
  name: "LanguageConfiguration",
  components: {},
  mixins: [validationMixin, policiesMixin],
  data() {
    return {
      languagesOptions: languagesOptions,
    };
  },
});
